import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Window, WindowContent, WindowHeader, Frame, Hourglass, Button } from 'react95';
import './TaxpayerInfoFormUploadModal.scss';
import { useDropzone } from 'react-dropzone';
import { isEmpty } from 'lodash-es';
import { useParams } from 'react-router-dom';
import { useGetTaskQuery, useUploadFormsMutation } from '../../api/opsSystemApi';

const UPLOAD_STATUSES = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILURE: 'failure'
};

const TaxpayerInfoFormUploadModal = ({ onClose }) => {
  const modalRef = useRef(null);
  const [dropzoneFiles, setDropzoneFiles] = useState([]);
  const [uploadStatus, setUploadStatus] = useState(null);

  const { taskId } = useParams();
  const { data: task = {}, isLoading: isTaskLoading } = useGetTaskQuery(taskId);

  const [uploadForms] = useUploadFormsMutation();

  const onDrop = useCallback(() => {
    const createUploadAttempts = async (forms = []) => {
      setUploadStatus(UPLOAD_STATUSES.PENDING);

      const formData = new FormData();
      forms.forEach((form) => formData.append('forms', form));
      formData.append('userId', task.user_id);
      formData.append('year', task.year);

      const res = await uploadForms({ taskId, formData });
      setUploadStatus(res.error ? UPLOAD_STATUSES.FAILURE : UPLOAD_STATUSES.SUCCESS);
    };

    if (!isEmpty(dropzoneFiles) && !uploadStatus) {
      createUploadAttempts(dropzoneFiles);
    }
  }, [uploadStatus, dropzoneFiles, setUploadStatus, task, taskId, uploadForms]);

  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    disabled: uploadStatus === UPLOAD_STATUSES.PENDING,
    accept: {
      'application/pdf': ['.pdf'],
      'image/*': ['.jpg', '.jpeg', '.png', '.tif', '.tiff']
    },
    multiple: true,
    onDrop
  });

  useEffect(() => {
    if (acceptedFiles.length) {
      setDropzoneFiles(acceptedFiles);
      setUploadStatus(null);
    }
  }, [acceptedFiles, setDropzoneFiles, setUploadStatus]);

  useEffect(() => {
    onDrop();
  }, [uploadStatus, dropzoneFiles, setUploadStatus, setDropzoneFiles, onDrop]);

  if (isTaskLoading) {
    return null;
  }

  return (
    <Window className='taxpayer-info-form-upload-modal' ref={modalRef}>
      <WindowHeader className='tp-info-container-title'>
        <p>Upload Forms</p>
        <Button primary square size='sm' variant='flat' onClick={onClose}>
          X
        </Button>
      </WindowHeader>
      <WindowContent>
        <Frame variant='field' className='taxpayer-info-form-upload-modal-body'>
          <div className='taxpayer-info-form-upload-item-bulk-container'>
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <div className='taxpayer-info-form-upload-item-drag-drop-text'>
                {uploadStatus === UPLOAD_STATUSES.PENDING ? (
                  <div className='taxpayer-info-form-upload-item-loading-container'>
                    <p>Uploading...</p>
                    <Hourglass />
                  </div>
                ) : (
                  <div>Drag and drop, choose file, or upload photo</div>
                )}
              </div>
            </div>
          </div>
          {uploadStatus === UPLOAD_STATUSES.SUCCESS && <p>Successfully uploaded files!</p>}
          {uploadStatus === UPLOAD_STATUSES.FAILURE && <p>Failed to upload files. Please try again.</p>}
        </Frame>
      </WindowContent>
    </Window>
  );
};

export default TaxpayerInfoFormUploadModal;
